import {decorate, computed} from 'mobx';

import {BaseFlowStore} from "../base-flow-store";

/**
 * CampingWorldFlowStore extends the BaseFlowStore which contains common functionality shared between flows
 */
export class CampingWorldFlowStore extends BaseFlowStore {

    constructor(props) {
        super(props);
        console.debug("CampingWorldFlowStore Initiated");
    }

    get hasCompletedCWPrequalForm () {
        return !!this.applicationUuid;
    }

    /**
     * Redirects to the next step in the flow
     *
     *  - flowStepName: the name of the step to redirect to
     */
    handleStepRedirection = (flowStepName) => {
        let destinationUrl;
        switch (flowStepName) {
            case "coapplicant":
                console.info("stepName: coapplicant - redirecting to coapplicant page");
                this.historyStore.history.push(this.getPrequalUrl("/coapplicant") + `?flowUuid=${this.applicationUuid}`);
                return;

            case "decisioning":
                if (this.isCoapplicantFlow) {
                    console.info("stepName: decisioning - coapp");
                    destinationUrl = this.getPrequalUrl(`/offers/${this.applicationUuid}/${this.primaryApplicantUuid}`);
                    this.historyStore.history.push(destinationUrl);
                }
                else {
                    console.info("stepName: decisioning - no coapp");
                    destinationUrl = this.getPrequalUrl(`/offers/${this.applicationUuid}`);
                    this.historyStore.history.push(destinationUrl);
                }
                return;

            default:
                const metadata = {
                    flowStepName,
                    applicationUuid: this.applicationUuid,
                    primaryApplicantUuid: this.primaryApplicantUuid,
                }
                console.error(`Unknown flow step name: ${flowStepName}, has to be implemented in handleStepRedirection`, metadata);
        }
    }
}

decorate(CampingWorldFlowStore, {
    hasCompletedCWPrequalForm: computed,
});
